import { PropsWithChildren } from "react";

import { Tabs } from "@narmi/design_system";
import { useNavigate } from "react-router-dom";
import { useUserConfiguration } from "@hooks/useUserConfiguration";

const TABS = ["cases", "payments", "declined"];

const FednowTabs = ({
  tab,
  children,
}: PropsWithChildren<{ tab: "cases" | "payments" | "declined" }>) => {
  const navigate = useNavigate();
  const { isFeatureEnabled } = useUserConfiguration();

  return (
    <div className="margin--x--xxl margin--y--l">
      <Tabs
        selectedIndex={TABS.indexOf(tab)}
        onTabChange={(idx: number) => {
          navigate(`/fednow/${TABS[idx]}`);
        }}
      >
        <Tabs.List>
          <Tabs.Tab label="Cases" tabId="cases" />
          <Tabs.Tab label="Payments" tabId="payments" />
          {(isFeatureEnabled("third_party_fednow_transaction_evaluations", "decision") ||
            isFeatureEnabled("third_party_fednow_transaction_evaluations", "report")) && (
            <Tabs.Tab label="Declined" tabId="declined" />
          )}
        </Tabs.List>
      </Tabs>
      {children}
    </div>
  );
};

export default FednowTabs;
